// Toast rendering lives in `BusinessProvider` now (`contexts/business-context.js`)
// — it needs to show even while that provider is gating `children` behind
// `<Loading />`/`<RequestFailed />`, which is exactly the state this
// component's own children (and this component itself) wouldn't exist in.
const FullScreenLayout = ({ children }) => {
  return (
    <div className="flex min-h-[100dvh] h-[100dvh] scrollbar-none relative">{children}</div>
  );
};

export default FullScreenLayout;
